export default "__VITE_ASSET__CStHiAIa__"